import React from 'react'
import { compose, pure } from 'recompose'
import PropTypes from 'prop-types'
import styles from './loadingSpinnerComponent.scss'
var Spinner = require('react-spinkit')
export function LoadingSpinner (props) {
  return (
    <div
      className={[
        styles.loading,
        props.loading ? styles.loadingVisible : styles.loadingHidden
      ].join(' ')}
    >
      <Spinner name='ball-clip-rotate-multiple' color='white' />
    </div>
  )
}
LoadingSpinner.propTypes = {
  loading: PropTypes.bool.isRequired
}

export default compose(pure)(LoadingSpinner)



// WEBPACK FOOTER //
// ./src/components/loadingSpinner/loadingSpinnerComponent.js